
import React, { FC, JSX } from "react";
import ExternalCandidatesTable from "../../components/externalCandidates/ExternalCandidatesTable";

const AdminExternalCandidates: FC = (): JSX.Element => {
  return (
    <ExternalCandidatesTable
      isAdminView={true}
      pageTitle="External Candidates"
      pageDescription="Search and manage external candidates from various sources"
    />
  );
};

export default AdminExternalCandidates;
